import { http } from './http';
import type { DriverStatusType, RiderProfile } from '@/types';

export const statusApi = {
  getStatus() {
    return http.get<{ status: DriverStatusType }>('/rider/status');
  },
  setStatus(status: DriverStatusType) {
    return http.put<{ status: DriverStatusType }>('/rider/status', { status });
  },
  getProfile() {
    return http.get<{ profile: RiderProfile }>('/rider/profile');
  },
  updateLocation(latitude: number, longitude: number) {
    return http.put('/rider/location', { latitude, longitude });
  },
};
